export class Field {
    constructor({
                    //attributes
                    id= null,
                    campaign_id = null,
                    type= '',
                    label= '',
                    order= 0,
                    visible= 0,
                    created_at= new Date(),
                    updated_at= new Date()
                    //relations
                } = {}) {

        //fill attributes

        this.id= id;
        this.campaign_id=campaign_id;
        this.type=type;
        this.label=label;
        this.order=order;
        this.visible=visible;
        this.created_at=created_at;
        this.updated_at=updated_at;


    }

}

export function createField(data={}) {
    return Object.freeze(new Field(data));
}